// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/99fd54cb/" + chunkId + "." + __webpack_require__.h() + ".v99fd54cb.js";
};